// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 28px 0;
  transition: all 0.3s ease;
  background: transparent;
}

.navbar--scrolled {
  background: rgba(253, 246, 236, 0.97);
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 20px rgba(200, 134, 10, 0.15);
  padding: 14px 0;
}

.navbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.brand-logo {
  height: 100px;
  width: auto;
  object-fit: contain;
  transition: height 0.3s ease;
}

.navbar--scrolled .brand-logo {
  height: 70px;
}

/* ── Desktop nav ── */
.navbar-links {
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;
}

.nav-link {
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-mid);
  transition: all 0.2s ease;
  white-space: nowrap;
}

.nav-link:hover {
  color: var(--gold);
  background: rgba(200, 134, 10, 0.08);
}

.nav-link.active {
  color: var(--gold);
  font-weight: 600;
  background: rgba(200, 134, 10, 0.1);
}

.nav-donate-btn {
  background: linear-gradient(135deg, var(--gold), var(--orange));
  color: var(--white) !important;
  padding: 9px 20px;
  border-radius: 50px;
  font-size: 0.88rem;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 3px 12px rgba(200, 134, 10, 0.35);
}

.nav-donate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(200, 134, 10, 0.45);
}

/* ── Hamburger ── */
.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: rgba(200, 134, 10, 0.08);
  border: 1.5px solid rgba(200, 134, 10, 0.2);
  border-radius: 10px;
  cursor: pointer;
  padding: 10px;
  transition: background 0.2s ease;
}

.hamburger:hover {
  background: rgba(200, 134, 10, 0.15);
}

.hamburger span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--gold-dark);
  border-radius: 4px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
.hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

/* ── Backdrop ── */
.drawer-backdrop {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 1099;
  background: rgba(44, 26, 6, 0.45);
  backdrop-filter: blur(2px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.drawer-backdrop.visible {
  opacity: 1;
  pointer-events: auto;
}

/* ── Mobile Drawer ── */
.mobile-drawer {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 300px;
  max-width: 85vw;
  z-index: 1100;
  background: var(--cream);
  box-shadow: -8px 0 40px rgba(44, 26, 6, 0.2);
  flex-direction: column;
  transform: translateX(100%);
  pointer-events: none;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
}

.mobile-drawer.open {
  transform: translateX(0);
  pointer-events: auto;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  border-bottom: 1px solid rgba(200, 134, 10, 0.15);
  background: rgba(253, 246, 236, 0.9);
}

.drawer-logo {
  height: 64px;
  width: auto;
  object-fit: contain;
}

.drawer-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(200, 134, 10, 0.1);
  border: 1.5px solid rgba(200, 134, 10, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.drawer-close:hover {
  background: rgba(200, 134, 10, 0.2);
}

.drawer-close svg {
  width: 18px;
  height: 18px;
  color: var(--gold-dark);
}

/* Nav links inside drawer */
.drawer-nav {
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  gap: 1px;
  flex: 1 1;
}

.drawer-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  border-radius: 10px;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--text-mid);
  transition: all 0.2s ease;
  text-decoration: none;
}

.drawer-link:hover {
  background: rgba(200, 134, 10, 0.08);
  color: var(--gold-dark);
}

.drawer-link.active {
  background: linear-gradient(135deg, rgba(200, 134, 10, 0.12), rgba(196, 72, 10, 0.06));
  color: var(--gold-dark);
  font-weight: 600;
}

.drawer-link-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gold-dark);
}

.drawer-link-icon svg {
  width: 18px;
  height: 18px;
}

.drawer-link span:nth-child(2) {
  flex: 1 1;
}

.drawer-link-arrow {
  width: 16px;
  height: 16px;
  color: rgba(200, 134, 10, 0.4);
  flex-shrink: 0;
  transition: transform 0.2s ease, color 0.2s ease;
}

.drawer-link:hover .drawer-link-arrow,
.drawer-link.active .drawer-link-arrow {
  color: var(--gold);
  transform: translateX(2px);
}

/* Drawer footer */
.drawer-footer {
  padding: 16px 20px 32px;
  border-top: 1px solid rgba(200, 134, 10, 0.15);
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.drawer-donate-btn {
  display: block;
  width: 100%;
  text-align: center;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  color: var(--white);
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  box-shadow: 0 4px 16px rgba(200, 134, 10, 0.35);
  transition: all 0.2s ease;
}

.drawer-donate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(200, 134, 10, 0.45);
}

.drawer-tagline {
  font-size: 0.78rem;
  color: var(--text-light);
  text-align: center;
}

/* ── Responsive breakpoint ── */
@media (max-width: 900px) {
  .hamburger       { display: flex; }
  .navbar-links    { display: none; }
  .drawer-backdrop { display: block; }
  .mobile-drawer   { display: flex; }

  .brand-logo {
    height: 90px;
  }

  .navbar--scrolled .brand-logo {
    height: 68px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,+DAA+D;EAC/D,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,oCAAoC,wCAAwC,EAAE;AAC9E,oCAAoC,UAAU,EAAE,oBAAoB,EAAE;AACtE,oCAAoC,0CAA0C,EAAE;;AAEhF,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,4CAA4C;EAC5C,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,sFAAsF;EACtF,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,gDAAgD;AAClD;;AAEA;;EAEE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,+DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB,aAAa,EAAE;EAClC,mBAAmB,aAAa,EAAE;EAClC,mBAAmB,cAAc,EAAE;EACnC,mBAAmB,aAAa,EAAE;;EAElC;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 28px 0;\n  transition: all 0.3s ease;\n  background: transparent;\n}\n\n.navbar--scrolled {\n  background: rgba(253, 246, 236, 0.97);\n  backdrop-filter: blur(12px);\n  box-shadow: 0 2px 20px rgba(200, 134, 10, 0.15);\n  padding: 14px 0;\n}\n\n.navbar-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.brand-logo {\n  height: 100px;\n  width: auto;\n  object-fit: contain;\n  transition: height 0.3s ease;\n}\n\n.navbar--scrolled .brand-logo {\n  height: 70px;\n}\n\n/* ── Desktop nav ── */\n.navbar-links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  list-style: none;\n}\n\n.nav-link {\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.nav-link:hover {\n  color: var(--gold);\n  background: rgba(200, 134, 10, 0.08);\n}\n\n.nav-link.active {\n  color: var(--gold);\n  font-weight: 600;\n  background: rgba(200, 134, 10, 0.1);\n}\n\n.nav-donate-btn {\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  color: var(--white) !important;\n  padding: 9px 20px;\n  border-radius: 50px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  box-shadow: 0 3px 12px rgba(200, 134, 10, 0.35);\n}\n\n.nav-donate-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(200, 134, 10, 0.45);\n}\n\n/* ── Hamburger ── */\n.hamburger {\n  display: none;\n  flex-direction: column;\n  gap: 5px;\n  background: rgba(200, 134, 10, 0.08);\n  border: 1.5px solid rgba(200, 134, 10, 0.2);\n  border-radius: 10px;\n  cursor: pointer;\n  padding: 10px;\n  transition: background 0.2s ease;\n}\n\n.hamburger:hover {\n  background: rgba(200, 134, 10, 0.15);\n}\n\n.hamburger span {\n  display: block;\n  width: 22px;\n  height: 2px;\n  background: var(--gold-dark);\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }\n.hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }\n.hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }\n\n/* ── Backdrop ── */\n.drawer-backdrop {\n  display: none;\n  position: fixed;\n  inset: 0;\n  z-index: 1099;\n  background: rgba(44, 26, 6, 0.45);\n  backdrop-filter: blur(2px);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.drawer-backdrop.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* ── Mobile Drawer ── */\n.mobile-drawer {\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 300px;\n  max-width: 85vw;\n  z-index: 1100;\n  background: var(--cream);\n  box-shadow: -8px 0 40px rgba(44, 26, 6, 0.2);\n  flex-direction: column;\n  transform: translateX(100%);\n  pointer-events: none;\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow-y: auto;\n}\n\n.mobile-drawer.open {\n  transform: translateX(0);\n  pointer-events: auto;\n}\n\n.drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px 16px;\n  border-bottom: 1px solid rgba(200, 134, 10, 0.15);\n  background: rgba(253, 246, 236, 0.9);\n}\n\n.drawer-logo {\n  height: 64px;\n  width: auto;\n  object-fit: contain;\n}\n\n.drawer-close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(200, 134, 10, 0.1);\n  border: 1.5px solid rgba(200, 134, 10, 0.2);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.drawer-close:hover {\n  background: rgba(200, 134, 10, 0.2);\n}\n\n.drawer-close svg {\n  width: 18px;\n  height: 18px;\n  color: var(--gold-dark);\n}\n\n/* Nav links inside drawer */\n.drawer-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 10px;\n  gap: 1px;\n  flex: 1;\n}\n\n.drawer-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 14px;\n  border-radius: 10px;\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n\n.drawer-link:hover {\n  background: rgba(200, 134, 10, 0.08);\n  color: var(--gold-dark);\n}\n\n.drawer-link.active {\n  background: linear-gradient(135deg, rgba(200, 134, 10, 0.12), rgba(196, 72, 10, 0.06));\n  color: var(--gold-dark);\n  font-weight: 600;\n}\n\n.drawer-link-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--gold-dark);\n}\n\n.drawer-link-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.drawer-link span:nth-child(2) {\n  flex: 1;\n}\n\n.drawer-link-arrow {\n  width: 16px;\n  height: 16px;\n  color: rgba(200, 134, 10, 0.4);\n  flex-shrink: 0;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.drawer-link:hover .drawer-link-arrow,\n.drawer-link.active .drawer-link-arrow {\n  color: var(--gold);\n  transform: translateX(2px);\n}\n\n/* Drawer footer */\n.drawer-footer {\n  padding: 16px 20px 32px;\n  border-top: 1px solid rgba(200, 134, 10, 0.15);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n}\n\n.drawer-donate-btn {\n  display: block;\n  width: 100%;\n  text-align: center;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  color: var(--white);\n  padding: 14px 20px;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 700;\n  box-shadow: 0 4px 16px rgba(200, 134, 10, 0.35);\n  transition: all 0.2s ease;\n}\n\n.drawer-donate-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(200, 134, 10, 0.45);\n}\n\n.drawer-tagline {\n  font-size: 0.78rem;\n  color: var(--text-light);\n  text-align: center;\n}\n\n/* ── Responsive breakpoint ── */\n@media (max-width: 900px) {\n  .hamburger       { display: flex; }\n  .navbar-links    { display: none; }\n  .drawer-backdrop { display: block; }\n  .mobile-drawer   { display: flex; }\n\n  .brand-logo {\n    height: 90px;\n  }\n\n  .navbar--scrolled .brand-logo {\n    height: 68px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
